import { render, staticRenderFns } from "./respuestaPayuTendero.vue?vue&type=template&id=dcea13a0&"
import script from "./respuestaPayuTendero.vue?vue&type=script&lang=js&"
export * from "./respuestaPayuTendero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports